export const EVENT_LAYOUTS = {
    DEFAULT: 'default',
    SCHEDULE: 'schedule',
};

export const SESSION_KINDS = [
    { value: 'talk', label: 'Palestra' },
    { value: 'workshop', label: 'Minicurso' },
    { value: 'panel', label: 'Mesa-redonda' },
    { value: 'ceremony', label: 'Cerimônia' },
    { value: 'other', label: 'Outro' },
];

const WEEKDAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

/** Nome do tipo da sessão; em "outro" vale o que o produtor digitou. */
export function kindLabel(session) {
    if (session?.kind === 'other' && session?.kind_label) {
        return session.kind_label;
    }

    return SESSION_KINDS.find(item => item.value === session?.kind)?.label || 'Atividade';
}

/** Palestrantes da sessão, com fallback para o texto corrido antigo. */
export function speakersOf(session) {
    if (session?.speakers?.length) {
        return session.speakers;
    }

    return session?.speaker ? [{ id: null, name: session.speaker, photo_url: null }] : [];
}

/** A página só troca de layout quando o produtor escolheu e já há o que mostrar. */
export function hasScheduleLayout(event) {
    return event?.layout === EVENT_LAYOUTS.SCHEDULE && !!event?.sessions?.length;
}

/** "2026-11-09" -> { weekday: 'Seg', label: '09/11' } */
export function formatDay(day) {
    const [year, month, date] = String(day).split('-');
    const weekday = WEEKDAYS[new Date(`${day}T12:00:00`).getDay()];

    return { weekday, label: `${date}/${month}`, year };
}

/** Dias em que o evento acontece, em ordem e sem repetir ("2026-11-09"). */
export function eventDays(event) {
    const days = (event?.dates || []).map(item => String(item?.date || '').slice(0, 10)).filter(Boolean);

    return [...new Set(days)].sort();
}

function clock(value) {
    const found = String(value || '').match(/(\d{1,2}):(\d{2})/);

    return found ? `${found[1].padStart(2, '0')}:${found[2]}` : '';
}

/**
 * Horário em que o evento acontece naquele dia ("09:00" a "21:00"), para a sessão
 * já nascer com ele. Um fim antes do início (evento que passa da meia-noite) não
 * serve de fim de sessão, que a API recusa; nesse caso o fim fica em branco.
 */
export function eventHours(event, day) {
    const item = (event?.dates || []).find(entry => String(entry?.date || '').slice(0, 10) === day);

    if (!item) {
        return null;
    }

    const start = clock(item.start);
    const end = clock(item.end);

    return { start, end: start && end && end <= start ? '' : end };
}

export function groupSessionsByDay(sessions = []) {
    const days = {};

    sessions.forEach(session => {
        (days[session.date] = days[session.date] || []).push(session);
    });

    return Object.keys(days)
        .sort()
        .map(date => ({
            date,
            items: days[date].sort((a, b) => `${a.start}`.localeCompare(`${b.start}`) || a.sort_order - b.sort_order),
        }));
}

export function ticketProducts(event) {
    return (event?.products || []).filter(product => product.type === 'ticket');
}

/** Tem lote à venda? Evita oferecer, numa sessão, um ingresso que já esgotou. */
export function availableBatch(product) {
    return (product?.batches || []).find(batch => batch.is_active && batch.quantity_available > 0 && !batch.upcoming) || null;
}

/**
 * Ingressos do evento (passe): os que nenhuma sessão usa como acesso. Quem não
 * tem um deles ainda não pode escolher sessões. A lista vem da API, que aplica
 * a mesma regra na hora de aceitar o pedido.
 */
export function passProducts(event) {
    const ids = event?.pass_product_ids || [];

    return ticketProducts(event).filter(product => ids.includes(product.id));
}

/** O evento só exige o passe quando vende algum. */
export function requiresPass(event) {
    return (event?.pass_product_ids || []).length > 0;
}
